import { Routes } from '@angular/router';

import { authGuard } from './auth/auth.guard';
import { guestGuard } from './auth/guest.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/dashboard/home',
        pathMatch: 'full',
    },
    {
        path: 'login',
        canActivate: [guestGuard],
        loadComponent: () =>
            import('./auth/login/login.component').then((m) => m.LoginComponent),
    },
    {
        path: 'login/complete',
        loadComponent: () =>
            import('./auth/login/login-complete.component').then(
                (m) => m.LoginCompleteComponent,
            ),
    },
    {
        path: 'dashboard',
        canActivate: [authGuard],
        loadComponent: async () =>
            import('./features/dashboard/dashboard.component').then(
                (m) => m.DashboardComponent,
            ),
        loadChildren: async () => import('./features/dashboard/dashboard.routes'),
    },
];
